import React from "react";
import SearchBar from "../SearchBar/SearchBar";

const HeroSection = ({ searchResult, setSearchResult, handleFilter }) => {
  const options = [
    "",
    "Al Barari",
    "Al Barsha",
    "Al Furjan",
    "Al Habtoor City",
    "Al Hamra Village",
    "Al Jaddaff",
    "Al Jurf",
    "Al Kifaf",
    "Al Marjan Island",
    "Al Reem Island",
    "Al Safa",
    "Al Sufouh",
    "Al Wasl",
    "Al Zorah",
    "Arabian Ranches",
    "Arabian Ranches 2",
    "Arabian Ranches 3",
    "Arjan",
    "Bluewaters Island",
    "Burj Khalifa District",
    "Business Bay",
    "City Walk",
    "Culture Village",
    "DIFC",
    "Deira",
    "Downtown Dubai",
    "Downtown Jebel Ali",
    "Dubai Canal",
    "Dubai Creek Harbour",
    "Dubai Festival City",
    "Dubai Healthcare City",
    "Dubai Hills Estate",
    "Dubai Investment Park",
    "Dubai Islands",
    "Dubai Marina",
    "Dubai Production City",
    "Silicon Oasis",
    "Dubai South",
    "Dubai Sports City",
    "Dubailand",
    "Emaar Beachfront",
    "Emaar South",
    "Emirates Hills",
    "Emirates Living",
    "Expo City Dubai",
    "Falconcity",
    "Hudayriyat Island",
    "International City",
    "JBR",
    "Jebel Ali",
    "Jebel Ali Village",
    "Jumeira Bay",
    "Jumeirah",
    "Jumeirah Golf Estate",
    "Jumeirah Height",
    "Jumeirah Islands",
    "Jumeirah Lake Towers",
    "Jumeirah Park",
    "Jumeirah Village Circle",
    "Jumeirah Village Triangle",
    "MBR City",
    "Madinat Badr",
    "Madinat Jumeirah Living",
    "Majan",
    "Marine Drive",
    "Meadows",
    "Meydan City",
    "Mirdif Hills",
    "Motor City",
    "Mudon",
    "Muscat Bay",
    "Nad Al Hammar",
    "Nad Al Sheba",
    "Palm Jebel Ali",
    "Palm Jumeirah",
    "Pearl Jumeirah",
    "Port De La Mer",
    "Remraam",
    "Sheikh Zayed Road",
    "Sobha Hartland",
    "Springs",
    "Studio City",
    "The Lakes",
    "The Opera District",
    "The Valley",
    "The Views",
    "Tilal Al Ghaf",
    "Town Square",
    "Umm Suqeim",
    "Villanova",
    "Yas Bay",
    "Zaabeel",
  ];

  return (
    <section
      className="relative h-[70vh] md:h-[80vh] *:font-sans flex flex-col justify-center items-center"
      style={{
        overflow: "hidden",
      }}
    >
      <video
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-[85vh] object-cover video1"
        style={{
          zIndex: "-1",
        }}
      >
        <source
          src="https://videos.pexels.com/video-files/8396975/8396975-hd_1280_720_25fps.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* Content of the section */}

      {/* <div className="absolute inset-0 bg-black opacity-25"></div> */}

      <div className="absolute flex items-center justify-center w-full ">
        <SearchBar
          handleFilter={handleFilter}
          searchResult={searchResult}
          setSearchResult={setSearchResult}
          options={options}
        />
      </div>
    </section>
  );
};

export default HeroSection;
